import type { WizardChatEnginePersistenceProps } from '@lemonade-hq/chat-wizard-client-base';
import { useI18nContext } from '@lemonade-hq/nuiza';
import { useNavContext } from '@lemonade-hq/uniclient-app';
import type { UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import { useCallback } from 'react';
import { errorStep401, errorStep403, errorStepGeneral } from '../error-steps';
import { errorStep410 } from '../error-steps/410';

interface ErrorData {
  readonly message: string;
  readonly statusCode: number;
}

export function useUniclientPersistenceErrorMap(): Required<
  WizardChatEnginePersistenceProps<UniclientStepPresentation>
>['errorMap'] {
  const { s } = useI18nContext();
  const {
    auth: { logoutUrl, loginUrl },
    nav: { homeUrl },
  } = useNavContext();

  return useCallback<Required<WizardChatEnginePersistenceProps<UniclientStepPresentation>>['errorMap']>(
    (err, action) => {
      const { message, statusCode } = (err.response?.data ?? {}) as ErrorData;

      const login = new URL(loginUrl);
      login.searchParams.set('redirect_url', window.location.href);
      if (message === 'Unauthorized' || statusCode === 401) {
        return errorStep401({ s, urls: { login: login.toString() } });
      } else if (statusCode === 403) {
        const logout = new URL(logoutUrl);
        logout.searchParams.set('redirect_url', login.toString());
        return errorStep403({ s, urls: { home: homeUrl, logout: logout.toString() } });
      } else if (statusCode === 410) {
        return errorStep410({ s });
      } else if (statusCode !== 404 && action === 'init') {
        return errorStepGeneral({ s, urls: { home: homeUrl } });
      }
    },
    [s, homeUrl, loginUrl, logoutUrl],
  );
}
